<div class="p-grid p-m-0">
  <div class="p-col-2 p-sm-2 p-md-3 p-lg-2 p-xl-2 sidebar-container">
    <app-sidebar [menus]="menus"></app-sidebar>
  </div>
  <div class="p-col-10 p-sm-10 p-md-9 p-lg-10 p-xl-10" style="background-color: #e9edf2">
    <div class="p-grid">

      <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between p-px-2 p-px-sm-2 p-px-md-3 p-px-lg-2 p-px-xl-2" style="color: #232c70;">
          <div>
            <h2>{{nombreMenuActivo}}</h2>
          </div>
          <div>
            <p>Sesión iniciada como <b>{{postulante.nombres}} {{postulante.paterno}}</b></p>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-sm-12 p-md-12 p-lg-8 p-xl-8">
        <router-outlet></router-outlet>
      </div>
    
      <!-- Columna tips plataforma -->
      <div class="p-col-12 p-sm-12 p-md-12 p-lg-4 p-xl-4">
        <app-consejos></app-consejos>
      </div>
    </div>
  </div>
</div>


